import '@css/base/reset.css';

import { HashRouter, Route, Routes } from 'react-router-dom';

import AdminLogin from '@carrier/pages/AdminLogin';
import Admins from '@carrier/pages/admins/List';
import ApiTokens from '@carrier/pages/ApiTokens';
import AmbestRecords from '@carrier/pages/ambest_records/List';
import Authenticated from '@carrier/Authenticated';
import CarrierShow from '@carrier/pages/carriers/Show';
import Carriers from '@carrier/pages/carriers/List';
import React from 'react';
import Resources from '@carrier/pages/resources/Index';
import Vendor from '@carrier/pages/vendors/Show';
import Vendors from '@carrier/pages/vendors/List';
import { Provider } from 'react-redux';
import store from '../redux/store';
import { createRoot } from 'react-dom/client';
import posthog from 'posthog-js';
import { PostHogProvider } from 'posthog-js/react';

const container = document.getElementById('root');
const root = createRoot(container);

const config = require('../config');

posthog.init(config.PostHogKey, {
  api_host: 'https://us.i.posthog.com'
});

root.render(
  <React.StrictMode>
    <PostHogProvider client={posthog}>
      <Provider store={store}>
        <HashRouter>
          <Routes>
            <Route element={<AdminLogin />} index={true} />
            <Route element={<Authenticated />}>
              <Route element={<Admins />} path='admins' />
              <Route element={<ApiTokens />} path='api_tokens' />
              <Route element={<Resources />} path='resources/*' />
              <Route element={<AmbestRecords />} path='ambest_records' />
              <Route element={<Vendors />} path='vendors' />
              <Route element={<Vendor />} path='vendors/:id/*' />
              <Route element={<Carriers />} path='carriers' />
              <Route element={<CarrierShow />} path='carriers/:id/*' />
            </Route>
          </Routes>
        </HashRouter>
      </Provider>
    </PostHogProvider>
  </React.StrictMode>
);
